//
//
//
//
//
//
//
//
//
//

export default {
  mounted() {
    window.setTimeout(() => {
      this.$router.push({ name: 'dashboard' });
    }, 3000);
  },
};



// WEBPACK FOOTER //
// ./src/spa/NotFound.vue?vue&type=script&lang=js&